// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "img[data-v-13c4b6bf]{background:#fff;cursor:zoom-in;display:block;height:auto;margin-left:auto;margin-right:auto;max-width:100%}.image-container.text img[data-v-13c4b6bf],.image-container.wide img[data-v-13c4b6bf]{border-radius:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
